import type { ReactNode } from "react";
import type { EvidenceReference } from "@pushback-and-chaos/contracts";
import { HOME } from "../design/copy.js";
import { Pill } from "./primitives.js";

/**
 * "VIEW THE MOMENT" (coach plan step 5, C05): the control under a coach line
 * that points at where its words came from. One pill per reference the
 * server built from what the coach cited; a press opens the debrief of that
 * engagement at that moment, through the debrief route's own ownership
 * check. Nothing here is a number: the moment is an ordinal in words, the
 * reading is one of the record's four words, and whose words the excerpt is
 * comes from the reference's attribution, never from the prose.
 */
const ORDINALS = ["first", "second", "third", "fourth", "fifth", "sixth", "seventh", "eighth", "ninth", "tenth"] as const;

/** Where a reference points, in words: "Harborlight Veterinary Group, third moment". */
export function momentWords(reference: EvidenceReference): string {
  if (reference.moment === null) return reference.engagement;
  const ordinal = ORDINALS[reference.moment - 1] ?? "a later";
  return `${reference.engagement}, ${ordinal} moment`;
}

export function EvidenceLinks({ references, onView }: { readonly references: readonly EvidenceReference[]; readonly onView?: ((reference: EvidenceReference) => void) | undefined }): ReactNode {
  if (references.length === 0) return null;
  return (
    <div data-testid="evidence-links" className="mb-6">
      <p className="pcs-quiet m-0 mb-2">{HOME.viewMomentLabel}</p>
      <div className="flex flex-wrap gap-4">
        {references.map((reference) => (
          <Pill key={reference.id} onClick={() => onView?.(reference)} disabled={onView === undefined} title={`${HOME.evidenceAttribution[reference.attribution]}: “${reference.excerpt}”`}>
            {momentWords(reference)} · {HOME.viewMoment}
          </Pill>
        ))}
      </div>
    </div>
  );
}
